export const enum WorldUpdateType {
  CREATE = "create",
}
